import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';

export interface Partner {
  id: number;
  name: string;
  kbo: string;
  vatNumber: string;
  IbanNumber: string;
  defaultPartnerFee: number;
  discountFee: number;
  type: string;
  subtype: string;
  activeCommision: number;
  billingEmail: string;
  billingAddressStreet: string;
  billingAddressNumber: string;
  billingAddressCity: string;
  billingAddressZip: string;
  partner_revenue_bess_default: number;
  partner_profit_share_bess_default: number | null;
  partner_fee_bess_default: number;
  partner_fee_asset: number | null;
  phone: string;
  website: string;
}

interface PartnerPayload {
  data: {
    partners: Partner[];
  };
}

interface PartnerState {
  partners: Partner[];
  status: 'idle' | 'loading' | 'failed';
  error: string | null;
}

const initialState: PartnerState = {
  partners: [],
  status: 'idle',
  error: null,
};
export const fetchPartners = createAsyncThunk<PartnerPayload, { token: string }>(
  'partners/fetchPartners',
  async ({ token }) => {
    const response = await axios.get(`${import.meta.env.VITE_AUTH_BASE_URL}/api/v1/partners/`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return response.data;
  },
);

const partnerSlice = createSlice({
  name: 'partner',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPartners.pending, (state) => {
      state.status = 'loading';
      state.error = null;
    });
    builder.addCase(fetchPartners.fulfilled, (state, action: PayloadAction<PartnerPayload>) => {
      state.status = 'idle';
      // Extract the partners from `action.payload.data.partners`
      state.partners = action.payload.data.partners;
    });
    builder.addCase(fetchPartners.rejected, (state, action) => {
      state.status = 'failed';
      state.error = action.error.message || 'Failed to load partners';
    });
  },
});

export default partnerSlice.reducer;
